import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "form-dialog__title" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "发票邮寄地址", -1)
const _hoisted_3 = {
  class: "form-dialog__content",
  style: {"display":"block"}
}
const _hoisted_4 = { style: {"display":"flex","justify-content":"space-between"} }

import { withDefaults, ref, watchEffect } from 'vue';
import {
  BaseButton,
  BaseForm,
  BaseFormItem,
  BaseInput,
  BaseCheckbox,
  BaseCard,
  XrkMessage
} from 'xrk-components';
import { BasicInformationData } from '@V/invoice/src/data-source/types';
import { invoicePostalAddressEditor } from '@V/invoice/src/data-source/apis';

type AddressList = BasicInformationData['addressList'];


export default /*#__PURE__*/_defineComponent({
  __name: 'invoice-enterprise-dialog-address',
  props: {
    remove: { type: Function, default() {
      return () => {
        console.log('remove');
      };
    } },
    value: {}
  },
  setup(__props: any) {

const props = __props;

const formRef = ref(null);
const formData = ref<{ address: AddressList }>({ address: [] });
const disabled = ref(true); // false表示可编辑并按钮变为保存

watchEffect(() => {
  formData.value = { address: props.value };
});

const createProp = (index, key) => {
  return `address.${index}.${key}`;
};

const onAdd = () => {
  formData.value.address.push({
    id: null,
    name: '',
    phone: '',
    address: '',
    mailAddress: '',
    isDefault: 0,
    email: ''
  });
};
const onRemove = index => {
  formData.value.address.splice(index, 1);
};
const onCheckbox = (val, index) => {
  // 只可选中一个，全部改成0再修改目标值
  formData.value.address.forEach((_, index) => {
    formData.value.address[index].isDefault = 0;
  });
  formData.value.address[index].isDefault = val;
};
const onSave = async () => {
  // 保存
  if (!disabled.value) {
    if (!formData.value.address.some(item => item.isDefault)) {
      return XrkMessage.error('请选择默认发票邮寄地址');
    }
    await formRef.value.validate();
    await invoicePostalAddressEditor(formData.value.address);
  }
  disabled.value = !disabled.value;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseForm), {
    ref_key: "formRef",
    ref: formRef,
    "label-position": "top",
    model: formData.value
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        (disabled.value || (!disabled.value && formData.value.address.length))
          ? (_openBlock(), _createBlock(_unref(BaseButton), {
              key: 0,
              size: "small",
              click: onSave
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(disabled.value ? '编辑' : '保存'), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!disabled.value && formData.value.address.length < 5)
          ? (_openBlock(), _createBlock(_unref(BaseButton), {
              key: 1,
              size: "small",
              type: "primary2",
              onClick: onAdd
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 新增 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.value.address, (item, index) => {
          return (_openBlock(), _createBlock(_unref(BaseCard), {
            style: {"margin-bottom":"15px"},
            shadow: "hover",
            key: index
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_unref(BaseFormItem), {
                  style: {"margin-bottom":"0"},
                  prop: "",
                  label: `默认地址${index + 1}`,
                  "label-position": "left"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(BaseCheckbox), {
                      disabled: disabled.value,
                      "true-value": 1,
                      "false-value": 0,
                      modelValue: formData.value.address[index].isDefault,
                      "onUpdate:modelValue": ($event: any) => ((formData.value.address[index].isDefault) = $event),
                      onChange: e => onCheckbox(e, index)
                    }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "onChange"])
                  ]),
                  _: 2
                }, 1032, ["label"]),
                (!disabled.value)
                  ? (_openBlock(), _createBlock(_unref(BaseButton), {
                      key: 0,
                      size: "small",
                      type: "text",
                      onClick: ($event: any) => (onRemove(index))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 删除 ")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_unref(BaseFormItem), {
                label: "收件人",
                prop: createProp(index, 'name'),
                rules: [{ required: true, message: '请输入', trigger: 'blur' }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(BaseInput), {
                    class: "form-dialog__w280",
                    placeholder: "请输入",
                    type: "text",
                    disabled: disabled.value,
                    modelValue: formData.value.address[index].name,
                    "onUpdate:modelValue": ($event: any) => ((formData.value.address[index].name) = $event)
                  }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
                ]),
                _: 2
              }, 1032, ["prop"]),
              _createVNode(_unref(BaseFormItem), {
                label: "联系电话",
                prop: createProp(index, 'phone'),
                rules: [{ required: true, message: '请输入', trigger: 'blur' }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(BaseInput), {
                    class: "form-dialog__w280",
                    placeholder: "请输入",
                    type: "tel",
                    disabled: disabled.value,
                    modelValue: formData.value.address[index].phone,
                    "onUpdate:modelValue": ($event: any) => ((formData.value.address[index].phone) = $event)
                  }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
                ]),
                _: 2
              }, 1032, ["prop"]),
              _createVNode(_unref(BaseFormItem), {
                label: "邮寄地址",
                prop: createProp(index, 'mailAddress'),
                rules: [{ required: true, message: '请输入', trigger: 'blur' }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(BaseInput), {
                    class: "form-dialog__w280",
                    placeholder: "请输入",
                    type: "text",
                    disabled: disabled.value,
                    modelValue: formData.value.address[index].mailAddress,
                    "onUpdate:modelValue": ($event: any) => ((formData.value.address[index].mailAddress) = $event)
                  }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
                ]),
                _: 2
              }, 1032, ["prop"]),
              _createVNode(_unref(BaseFormItem), {
                label: "邮箱",
                prop: createProp(index, 'email'),
                rules: [{ required: true, message: '请输入', trigger: 'blur' }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(BaseInput), {
                    class: "form-dialog__w280",
                    placeholder: "请输入",
                    type: "text",
                    disabled: disabled.value,
                    modelValue: formData.value.address[index].email,
                    "onUpdate:modelValue": ($event: any) => ((formData.value.address[index].email) = $event)
                  }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
                ]),
                _: 2
              }, 1032, ["prop"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["model"]))
}
}

})